import {Fragment} from "react";
import InternalNoteContent from "./InternalNoteContent";
import useViewNextMessage from "../../../../Utilities/hooks/useViewNextMessage";

export default function InternalNoteContainer({handleClose, handleOptionSubmitted,message}) {
    const {message: nextMessage} = useViewNextMessage();

    return(
        <Fragment>
            <InternalNoteContent
                message={message || nextMessage}
                handleClose={handleClose}
                handleOptionSubmitted={handleOptionSubmitted}
            />
        </Fragment>
    )
}

